package com.anjuros.website.templates.template8.components

import androidx.compose.runtime.Composable

import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.language.LocalText

import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.util.Constants
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.modules.Template8Info
import com.anjuros.website.templates.template8.styles.Template8ButtonStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8InfoCard(
    infoCard:Template8Info,
    animatedOpacity:Float,
    clickable: Boolean = true
){
    Box(
        modifier = Modifier
            .id("info${infoCard.ordinal}")
            .width(356.px)
            .margin(topBottom = 30.px)
            .padding(topBottom = 2.px)
            .backgroundImage(
                linearGradient(
                    Template8Theme.Gold1.rgb,
                    Template8Theme.Gold2.rgb,
                    LinearGradient.Direction.ToTopRight
                )
            ) .boxShadow(
                4.px, 4.px, 10.0.px, 2.0.px, color = Theme.DarkGrey.rgb, false
            )

    ) {
    Box(
        modifier = Modifier
            .align(Alignment.Center)
            .width(350.px)
            .backgroundColor(Colors.White)


    ) {

        Column(
            modifier = Modifier,
            verticalArrangement = Arrangement.SpaceBetween,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            AnjurosImage(
                modifier = Modifier
                    .size(350.px, 200.px),
                src = infoCard.image,
                alt = "Pub menu"
            )

            P(
                attrs = Modifier
                    .opacity(animatedOpacity)
                    .transition(Transition.of(property = "opacity", duration = 1500.ms, delay = 400.ms*infoCard.ordinal))
                    .padding(40.px)
                    .textAlign(TextAlign.Justify)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Normal)
                    .fontStyle(FontStyle.Italic)
                    .color(Template8Theme.Primary.getColor())
                    .toAttrs()
            ) {
                Text(LocalText(infoCard.description))

            }

            ButtonInfoCard(
                infoCard = infoCard,
                clickable = clickable
            )


        }
    }
    }
}

@Composable
fun ButtonInfoCard(
    infoCard: Template8Info,
    clickable: Boolean = true
){
    Box(
        modifier = Template8ButtonStyle.toModifier()
            .margin(bottom = 20.px)
            .backgroundColor(Template8Theme.Primary.getColor())
            .borderRadius(5.px)
            .boxShadow(
                2.px, 2.px, 8.0.px, 2.0.px, color = Template2Theme.DarkGrey.rgb, false
            )
    ) {
        Link(
            path = if(clickable) infoCard.buttonPath else "",
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None)
                .align(Alignment.Center),
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB

        ) {
            P(
                attrs = Modifier
                    .margin(5.px)
                    .align(Alignment.Center)
                    .fontFamily(Constants.FONT_FAMILY)
                    .color(Colors.White)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(infoCard.buttonText))
            }
        }
    }
}